const TIPO_USUARIO = {
  EXPEDICAO: 2,
  PORTARIA: 3,
  GESTOR_DOCAS: 5,
  TRANSPORTADORA: 6,
}

export default TIPO_USUARIO
